import http from "@/services/axios";
import { Cache } from "@/services/cache";
import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
    state: () => ({
        user: null,
    }),

    actions: {
        async fetchUser() {
            const { data } = await http.get("/auth/user");
            this.user = data.user
            this.triggerCheckingPolicies();
        },
        async login(username, password) {
            const { data } = await http.post('/auth/login', { username, password });
            Cache.set('token', data.token)
            this.fetchUser();
        },

        async triggerCheckingPolicies() {
            await http.get('/policy-setting/check-policies-for-renewal');
        },

        async loadToken(token) {
            const { data } = await http.post('/auth/validate-token', { token });
            Cache.set('token', data.token)
            this.fetchUser();
        }
    }
})